import React from "react";
import { Form, Select, DatePicker, Button } from "antd";

const { Option } = Select;
const { RangePicker } = DatePicker;

const itemStyles = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 6 },
    lg: { span: 5 },
    xl: { span: 5 },
    xxl: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 18 },
    lg: { span: 15 },
    xl: { span: 12 },
    xxl: { span: 12 },
  },
};

const LogDataSelectElement = (props) => {
  const { control, errors, SFTPJobData, Controller } = props;

  return (
    <>
      <Form.Item
        {...itemStyles}
        label="Job Name"
        help={errors?.jobId?.message}
        required
        validateStatus={errors?.jobId ? "error" : ""}
      >
        <Controller
          control={control}
          name="jobId"
          render={({ field: { onChange, value } }) => (
            <Select
              placeholder="Select The Job Name "
              showSearch
              allowClear
              filterOption={(input, option) => {
                return (
                  option.children.toLowerCase().indexOf(input.toLowerCase()) !==
                  -1
                );
              }}
              style={{ width: "90%" }}
              onChange={(values) => {
                onChange(values);
              }}
              value={value}
            >
              {SFTPJobData !== undefined
                ? SFTPJobData.map((SFTPJobDataElement) => {
                    return (
                      <Option
                        key={SFTPJobDataElement._id}
                        value={SFTPJobDataElement._id}
                      >
                        {SFTPJobDataElement.jobName}
                      </Option>
                    );
                  })
                : undefined}
            </Select>
          )}
        />
      </Form.Item>

      <Form.Item
        {...itemStyles}
        label="Date Range"
        validateStatus={errors?.businessDate ? "error" : ""}
        help={errors?.businessDate?.message}
        required
      >
        <Controller
          control={control}
          name="businessDate"
          render={({ field: { onChange, value } }) => (
            <RangePicker
              onChange={onChange}
              value={value}
              style={{ width: "90%" }}
              allowClear
              format="YYYY-MM-DD"
            />
          )}
        />
      </Form.Item>
      {/* define the button using form item  - added the change*/}

      <Form.Item wrapperCol={{ span: 10, offset: 5 }}>
        <Button type="primary" htmlType="submit">
          Find
        </Button>
      </Form.Item>
    </>
  );
};

export default LogDataSelectElement;
